/* globals document, window */
/* Responsibility: Load appNexusScript from JS so that it is simpler to not run during featureToggle-season. */
import { enableFeature } from '../../featureToggling/featureToggler.js';
export default function () {
    if (window.location.host.indexOf('localhost') < 0 && !enableFeature('noAds')) {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.defer = true;
        s.src = '//acdn.adnxs.com/ast/static/0.7.4/ast.js';
        const x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
    }
    window.apntag = window.apntag || {};
}



// WEBPACK FOOTER //
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/shared/overlay/src/main/webapp/scripts/banners/appNexus/loadAppNexus.js